export const convertRunPaceToSwimPace = ({ paceInSecondsPerMeter }) => paceInSecondsPerMeter * 100;
